import Swiper, { Navigation, FreeMode } from 'swiper';
import CalendarTable from './CalendarTable.js';

const defaultSelectors = {
  component: '.jsCalendarTable',
  monthTitle: '.calendar-table__month',
  yearTitle: '.calendar-table__year',
  slider: '.slider__inner',
  sliderPrevBtn: '.swiper-button-prev',
  sliderNextBtn: '.swiper-button-next',
  slide: '.swiper-slide',
  activeSlide: '.swiper-slide-active',
};

export default (options = {}) => {
  const selectors = {
    ...defaultSelectors,
    ...options?.selectors,
  };

  const block = document.querySelector(selectors.component);
  const infoMonth = block.querySelector(selectors.monthTitle);
  const infoYear = block.querySelector(selectors.yearTitle);
  const sliderNode = block.querySelector(selectors.slider);
  const sliderPrevBtn = block.querySelector(selectors.sliderPrevBtn);
  const sliderNextBtn = block.querySelector(selectors.sliderNextBtn);

  const changeInfo = (index) => {
    const hasActiveSlide = block.querySelector(selectors.activeSlide);

    if (!hasActiveSlide) {
      return;
    }

    const monthNodes = Array.from(block.querySelectorAll(selectors.slide));
    const activeMonthNode = monthNodes[index];
    const activeMonthDateString = activeMonthNode.getAttribute('data-calendar-date');

    const [month, year] = activeMonthDateString.split('; ');
    const currentMonthTitle = infoMonth.innerHTML;
    const currentYearTitle = infoYear.innerHTML;
    const newMonthTitle = `<span>${month}</span>`;
    const newYearTitle = `<span>${year}</span>`;
    const shouldUpdateMonthTitle = currentMonthTitle !== newMonthTitle;
    const shouldUpdateYearTitle = currentYearTitle !== newYearTitle;

    if (shouldUpdateMonthTitle) {
      infoMonth.innerHTML = newMonthTitle;
    }

    if (shouldUpdateYearTitle) {
      infoYear.innerHTML = newYearTitle;
    }
  };

  const slider = new Swiper(sliderNode, {
    modules: [Navigation, FreeMode],
    freeMode: true,
    loop: false,
    speed: 750,
    watchSlidesProgress: true,
    slidesPerView: 'auto',
    spaceBetween: 16,
    autoHeight: true,
    navigation: {
      prevEl: sliderPrevBtn,
      nextEl: sliderNextBtn,
    },
    breakpoints: {
      1024: {
        slidesPerView: 1,
        freeMode: false,
        spaceBetween: 0,
      },
    },
    on: {
      init() {
        changeInfo(this.activeIndex);
      },
      update() {
        changeInfo(this.activeIndex);
      },
      slideChange() {
        changeInfo(this.activeIndex);
      },
    },
  });

  const calendar = new CalendarTable({
    element: block,
  });

  if (options?.exportToGlobal) {
    window.calendarTable.slider = slider;
    window.calendarTable.main = calendar;
  }

  return {
    componentNode: block,
    slider,
    calendar,
  };
};
